import { EntDirectoryInfo } from "../../../models/directoryInfo";
import { ResponseData } from "../../../models/responseData";
import { agroApi } from "../api";


export class ResGetSelectList extends ResponseData {
    res: EntDirectoryInfo[] = [];
}

export const selectstApi = agroApi.injectEndpoints({
    endpoints: (builder) => ({
        getDistrictList: builder.query<ResGetSelectList, void>({
            query: () => ({
                url: "d-districts/list",
                method: "GET",
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetDistrictListQuery,
    useLazyGetDistrictListQuery
} = selectstApi;
